import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { ValueSection } from './components/ValueSection';
import { ProcessSection } from './components/ProcessSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
import { AnimatedBackground } from './components/AnimatedBackground';
export function App() {
  return <div className="min-h-screen bg-brand-black text-white selection:bg-brand-cyan/30 selection:text-white relative" data-id="element-0">
      <AnimatedBackground data-id="element-1" />
      <Navbar data-id="element-2" />

      <main className="relative z-10" data-id="element-3">
        <HeroSection data-id="element-4" />
        <ServicesSection data-id="element-5" />
        <ValueSection data-id="element-6" />
        <ProcessSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <CtaSection data-id="element-9" />
      </main>

      <Footer data-id="element-10" />
    </div>;
}